import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import php from '../img/php.png';
import "./About.css";

function Php() {
  // Script pour le burger menu
  useEffect(() => {
    const burger = document.getElementById("burger");
    const navLinks = document.getElementById("nav-links");

    const toggleMenu = () => {
      navLinks.classList.toggle("active");
      burger.classList.toggle("toggle");
    };

    burger.addEventListener("click", toggleMenu);

    return () => {
      burger.removeEventListener("click", toggleMenu);
    };
  }, []);

  return (
    <>
      <Header />

      <article className="competence-page">
        <h1>PHP</h1>

        <div className="competence-intro">
          <img src={php} alt="PHP" loading="lazy" />

          <p>
            <strong>PHP</strong> est un langage de programmation principalement
            utilisé pour développer des applications web dynamiques côté serveur.
          </p>

          <p>
            Il permet de générer du contenu dynamique, de gérer des formulaires,
            de communiquer avec des bases de données et de développer des
            applications web complètes.
          </p>
        </div>

        <section className="competence-details">
          <h2>Applications pratiques</h2>

          <ul>
            <li>Développement de sites et applications web dynamiques</li>
            <li>Création d'API et de services web</li>
            <li>Connexion et gestion de bases de données</li>
            <li>Traitement et validation de formulaires</li>
            <li>Gestion des sessions et des utilisateurs</li>
            <li>Développement côté serveur avec Laravel</li>
          </ul>

          <h2>Ressources pour débutants</h2>

          <ul>
            <li>
              <a
                href="https://www.php.net/manual/fr/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Documentation officielle PHP
              </a>
            </li>

            <li>
              <a
                href="https://www.php.net/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Site officiel PHP
              </a>
            </li>

            <li>
              <a
                href="https://developer.mozilla.org/fr/docs/Glossary/PHP"
                target="_blank"
                rel="noopener noreferrer"
              >
                PHP sur MDN
              </a>
            </li>
          </ul>
        </section>

        <Link to="/about" className="btn-back">
          ← Retour aux compétences
        </Link>
      </article>

      <Footer />
    </>
  );
}

export default Php;